import { useCurrentStateAndParams } from "@uirouter/react";

import type { IRouterState } from "single-spa/react-app/router/IRouterState";

import type { CompanyPageRoutingParams } from "../types/routing";

function useCurrentStateAndParamsWithFixedDomain(): { state: IRouterState; params: CompanyPageRoutingParams } {
    const { state, params } = useCurrentStateAndParams<CompanyPageRoutingParams>();

    const paramsWithFixedKey: CompanyPageRoutingParams = {
        ...params,
        key: params.key ? params.key.split(",")[0] : "",
    };

    return {
        state,
        params: paramsWithFixedKey,
    };
}

export default useCurrentStateAndParamsWithFixedDomain;
